<template>
    <div class="stdenis-indivsignup">
        <form role="form" @submit.prevent="submit_signup_details" class="vld-parent" ref="formContainer">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-lg-8 col-md-12 offset-lg-2 signup-container">
                        <div class="row">
                            <!-- Sign up Header -->
                            <div class="col-12 signup-head">
                                <div class="row">
                                    <div class="col-lg-2 col-md-12 head-img">
                                        <img src="../assets/images/logo/stdenislogo.jpeg" alt="" class="img-fluid">
                                    </div>
                                    <div class="col-lg-10 col-md-12 head-text" style="padding-top:10px">
                                        <h1 class="text text-danger text-center text-capitalize">
                                            St. Denis, Catholic church
                                        </h1>
                                        <h4 class="text-center">
                                            3/13, Thomas Drive, Akoka/ Bariga, Lagos
                                        </h4>
                                        <p class="text-center">Tel:+2348165214047&nbsp;&nbsp;Email:stdenis@stdenisakoka.org</p>
                                    </div>
                                </div>
                            </div>
                            <!-- Signup body -->
                            <div class="col-12 signup-body">
                                <div class="row signup-body-1">
                                    <div class="col-lg-12 col-md-12 head-text">
                                        <h4 class="text-center m-b-20">Membership Registration Form</h4>
                                    </div>
                                </div>


                                <div class="col-12 signup-body-header">
                                    <ul class="nav justify-content-center">
                                        <li class="nav-item">
                                            <a class="nav-link" :class="[sect_a_tab?'active':'']" @click.prevent="switchToTab('sectA')">Husband</a>
                                        </li>
                                        <li class="nav-item">
                                            <a class="nav-link" :class="[sect_b_tab?'active':'']" @click.prevent="switchToTab('sectB')">Wife</a>
                                        </li>
                                        <li class="nav-item">
                                            <a class="nav-link" :class="[sect_c_tab?'active':'']" @click.prevent="switchToTab('sectC')">Wards (optional)</a>
                                        </li>
                                    </ul>
                                </div>
                                <!--- SECTION A -->
                                <div class="container-fluid" :class="[sect_a_tab?'show':'hide']">
                                    <!-- first row -->
                                    <div class="row signup-body-1">
                                        <div class="col-12 head-text">
                                            <h4 class="m-b-20">Personal Data</h4>
                                        </div>
                                        <div class="col-lg-4 col-md-12 offset-lg-4">
                                            <div class="pic-frame js-personal" @click="toggle_passport_upload('1')">
                                                <div class="frame-overlay js-p-frame">
                                                    <span class="text text-dark"><i class="icon ion-md-hand"></i> click to upload passport</span>
                                                </div>
                                                <input type="file" class="frame-file" accept="image/*" id="stdenis-passport-1" @change="verify_profile_pic_upload('1')">
                                            </div>
                                        </div>
                                    </div>
                                    <!-- Second row -->
                                    <div class="row signup-body-2">

                                        <div class="col-lg-6 col-md-12 gap">
                                            <label for="surname-p" class="text-left">Surname:</label>
                                            <input type="text" class="form-control" id="surname-p" placeholder="Surname" v-model="personal_data.surname"  autofocus>
                                        </div>
                                        <div class="col-lg-6 col-md-12 gap">
                                            <label for="othername-p" class="text-left">Othernames:</label>
                                            <input type="text" class="form-control" id="othername-p" placeholder="Other Name" v-model="personal_data.othername" >
                                        </div>
                                        <div class="col-lg-6 col-md-12 gap">
                                            <label for="baptismalname-p" class="text-left">Baptismal Name:</label>
                                            <input type="text" class="form-control" id="baptismalname-p" placeholder="Baptismal Name" v-model="personal_data.baptismal_name" >
                                        </div>
                                        <div class="col-lg-6 col-md-12 gap">
                                            <label for="dob-p" class="text-left">Date of Birth:</label>
                                            <input type="date" class="form-control" id="dob-p" v-model="personal_data.dob" >
                                        </div>
                                        <div class="col-lg-6 col-md-12 gap">
                                            <label for="resident_addr-p" class="text-left">Residential Address:</label>
                                            <input type="text" class="form-control" id="resident_addr-p" placeholder="Address" v-model="personal_data.residential_addr" >
                                        </div>
                                        <div class="col-lg-6 col-md-12 gap">
                                            <label for="occupation-p" class="text-left">Occupation:</label>
                                            <input type="text" class="form-control" id="occupation-p" placeholder="Occupation" v-model="personal_data.occupation" >
                                        </div>
                                        <div class="col-lg-6 col-md-12 gap">
                                            <label for="mobile_tel-p" class="text-left">Mobile Number:</label>
                                            <input type="tel" class="form-control" id="mobile_tel-p" placeholder="Mobile Number" v-model="personal_data.mobile_no" >
                                        </div>
                                        <div class="col-lg-6 col-md-12 gap">
                                            <label for="u_email-p" class="text-left">Email Address:</label>
                                            <input type="email" class="form-control" id="u_email-p" placeholder="Email Address" v-model="personal_data.email" >
                                        </div>
                                        <div class="col-lg-6 col-md-12 gap">
                                            <label for="bcc_center-p" class="text-left">BCC Center:</label>
                                            <select class="form-control" v-model="personal_data.bcc_center" id="bcc_center-p">
                                                <option value="">Select a BCC Center</option>
                                                <option v-for="centers in bcc_centerID.length" :key="centers" :value="bcc_centerID[centers-1]">
                                                    {{bcc_centerName[centers-1]}}
                                                </option>
                                            </select>
                                        </div>
                                        <div class="col-lg-6 col-md-12 gap">
                                            <label for="u_joined-p" class="text-left">Year of Joining Church:</label>
                                            <input type="number" class="form-control" id="u_joined-p" placeholder="Year Joined" v-model="personal_data.yr_joined_church" >
                                        </div>
                                        <div class="col-lg-6 col-md-12 gap">
                                            <div class="row">
                                                <!--                                             Society Details-->
                                                <div class="col-12 gap">
                                                    <h4>Society Details</h4>
                                                </div>
                                                <div class="col-12 gap">
                                                    <div class="row">
                                                        <div class="col-lg-12 col-md-12">
                                                            <h6 class="text-left">Are you a Member of a Society?</h6>
                                                            <div class="col-12 text-left">
                                                                <div class="form-check form-check-inline">
                                                                    <label class="input-mask no-width form-check-input" :class="[personal_data.society_membership?'active':'']" @click="toggle_inputs_personal('society_membership', 'yes')">
                                                                        <input class="form-check-input" type="radio" id="society_membership1-p">
                                                                    </label>
                                                                    <label for="society_membership1" class="text-left no-width form-check-label">Yes</label>
                                                                </div>
                                                                <div class="form-check form-check-inline">
                                                                    <label class="input-mask no-width form-check-input" :class="[personal_data.society_membership?'':'active']" @click="toggle_inputs_personal('society_membership', 'no')">
                                                                        <input class="form-check-input" type="radio" id="society_membership2-p">
                                                                    </label>
                                                                    <label for="society_membership2-p" class="text-left no-width form-check-label" >No</label>
                                                                </div>
                                                            </div>
                                                            <div v-if="personal_data.society_membership">
                                                                <span><p class="text-warning">(hold down ctrl to select more than one society)</p></span>
                                                            </div>
                                                            <transition name="custom-name" enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
                                                                <template v-if="personal_data.society_membership">
                                                                    <select class="form-control" v-model="personal_data.society_name" multiple>
                                                                        <option v-for="society in societyID.length" :value="societyID[society-1]" :key="society">{{societyName[society-1]}}</option>
                                                                    </select>
                                                                </template>
                                                            </transition>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-12 gap">
                                            <div class="row">
                                                <!-- Sacramental Details-->
                                                <div class="col-12 gap">
                                                    <h4>Sacramental Details</h4>
                                                </div>
                                                <div class="col-12 gap">
                                                    <div class="row">
                                                        <div class="col-lg-6 col-md-12">
                                                            <h6 class="text-left">Are you Baptized?</h6>
                                                            <div class="col-12 text-left">
                                                                <div class="form-check form-check-inline">
                                                                    <label class="input-mask no-width form-check-input" :class="[personal_data.is_baptized?'active':'']" @click="toggle_inputs_personal('baptism', 'yes')">
                                                                        <input class="form-check-input" type="radio" id="baptized_yes-p">
                                                                    </label>
                                                                    <label for="baptized_yes" class="text-left no-width form-check-label">Yes</label>
                                                                </div>
                                                                <div class="form-check form-check-inline">
                                                                    <label class="input-mask no-width form-check-input" :class="[personal_data.is_baptized?'':'active']" @click="toggle_inputs_personal('baptism', 'no')">
                                                                        <input class="form-check-input" type="radio" id="baptized_no-p">
                                                                    </label>
                                                                    <label for="baptized_no" class="text-left no-width form-check-label" >No</label>
                                                                </div>
                                                            </div>
                                                            <transition name="custom-name" enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
                                                                <template v-if="personal_data.is_baptized">
                                                                    <div>
                                                                        <h6 class="text-left">Date of Baptism</h6>
                                                                        <div class="text-left">
                                                                            <input type="date" class="form-control" v-model="personal_data.baptized_date">
                                                                        </div>
                                                                    </div>
                                                                </template>
                                                            </transition>
                                                        </div>
                                                        <div class="col-lg-6 col-md-12">
                                                            <h6 class="text-left">Are you a Communicant?</h6>
                                                            <div class="col-12 text-left">
                                                                <div class="form-check form-check-inline">
                                                                    <label class="input-mask no-width form-check-input" :class="[personal_data.is_communicant?'active':'']" @click="toggle_inputs_personal('communicant', 'yes')">
                                                                        <input class="form-check-input" type="radio" id="communicant_yes-p">
                                                                    </label>
                                                                    <label for="communicant_yes-p" class="text-left no-width form-check-label">Yes</label>
                                                                </div>
                                                                <div class="form-check form-check-inline">
                                                                    <label class="input-mask no-width form-check-input" :class="[personal_data.is_communicant?'':'active']" @click="toggle_inputs_personal('communicant', 'no')">
                                                                        <input class="form-check-input" type="radio" id="communicant_no-p">
                                                                    </label>
                                                                    <label for="communicant_no-p" class="text-left no-width form-check-label" >No</label>
                                                                </div>
                                                            </div>
                                                            <transition name="custom-name" enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
                                                                <template v-if="personal_data.is_communicant">
                                                                    <div>
                                                                        <h6 class="text-left">Date of Communion</h6>
                                                                        <div class="text-left">
                                                                            <input type="date" class="form-control" v-model="personal_data.communion_date">
                                                                        </div>
                                                                    </div>
                                                                </template>
                                                            </transition>
                                                        </div>
                                                        <div class="col-lg-6 col-md-12">
                                                            <h6 class="text-left">Are you Confirmed?</h6>
                                                            <div class="col-12 text-left">
                                                                <div class="form-check form-check-inline">
                                                                    <label class="input-mask no-width form-check-input" :class="[personal_data.is_confirmed?'active':'']" @click="toggle_inputs_personal('confirmed', 'yes')">
                                                                        <input class="form-check-input" type="radio" id="confirmed_yes-p">
                                                                    </label>
                                                                    <label for="confirmed_yes-p" class="text-left no-width form-check-label">Yes</label>
                                                                </div>
                                                                <div class="form-check form-check-inline">
                                                                    <label class="input-mask no-width form-check-input" :class="[personal_data.is_confirmed?'':'active']" @click="toggle_inputs_personal('confirmed', 'no')">
                                                                        <input class="form-check-input" type="radio" id="confirmed_no-p">
                                                                    </label>
                                                                    <label for="confirmed_no-p" class="text-left no-width form-check-label" >No</label>
                                                                </div>
                                                            </div>
                                                            <transition name="custom-name" enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
                                                                <template v-if="personal_data.is_confirmed">
                                                                    <div>
                                                                        <h6 class="text-left">Date Confirmed</h6>
                                                                        <div class="text-left">
                                                                            <input type="date" class="form-control" v-model="personal_data.confirmed_date">
                                                                        </div>
                                                                    </div>
                                                                </template>
                                                            </transition>
                                                        </div>
                                                        <div class="col-lg-6 col-md-12">
                                                            <h6 class="text-left">Are you Married in the catholic church?</h6>
                                                            <div class="col-12 text-left">
                                                                <div class="form-check form-check-inline">
                                                                    <label class="input-mask no-width form-check-input" :class="[personal_data.is_married?'active':'']" @click="toggle_inputs_personal('married', 'yes')">
                                                                        <input class="form-check-input" type="radio" id="married_yes-p">
                                                                    </label>
                                                                    <label for="married_yes-p" class="text-left no-width form-check-label">Yes</label>
                                                                </div>
                                                                <div class="form-check form-check-inline">
                                                                    <label class="input-mask no-width form-check-input" :class="[personal_data.is_married?'':'active']" @click="toggle_inputs_personal('married', 'no')">
                                                                        <input class="form-check-input" type="radio" id="married_no-p">
                                                                    </label>
                                                                    <label for="married_no-p" class="text-left no-width form-check-label" >No</label>
                                                                </div>
                                                            </div>
                                                            <transition name="custom-name" enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
                                                                <template v-if="personal_data.is_married">
                                                                    <div class="p-t-20">
                                                                        <h6 class="text-left">Date of Marriage</h6>
                                                                        <div class="text-left">
                                                                            <input type="date" class="form-control" v-model="personal_data.married_date">
                                                                        </div>
                                                                        <h6 class="text-left">Name of Parish</h6>
                                                                        <div class="text-left">
                                                                            <input type="text" class="form-control" v-model="personal_data.married_parish">
                                                                        </div>

                                                                    </div>
                                                                </template>
                                                            </transition>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>


                                    </div>
                                    <!-- next tab -->
                                    <div class="row">
                                        <div class="col-lg-6 col-md-12 offset-lg-3">
                                            <button type="button" class="btn stdenis-btn" @click.prevent="switchToTab('sectB')">Proceed <i class="icon ion-md-arrow-forward"></i> </button>
                                        </div>
                                    </div>
                                </div>

                                <!--- SECTION B -->
                                <div class="container-fluid" :class="[sect_b_tab?'show':'hide']">
                                    <!-- first row -->
                                    <div class="row signup-body-1">
                                        <div class="col-12 head-text">
                                            <h4 class="m-b-20">Spouse Data</h4>
                                        </div>
                                        <div class="col-lg-4 col-md-12 offset-lg-4">
                                            <div class="pic-frame js-spouse" @click="toggle_passport_upload('2')">
                                                <div class="frame-overlay js-s-frame">
                                                    <span class="text text-dark"><i class="icon ion-md-hand"></i> click to upload passport</span>
                                                </div>
                                                <input type="file" class="frame-file" accept="image/*" id="stdenis-passport-2" @change="verify_profile_pic_upload('2')">
                                            </div>
                                        </div>
                                    </div>
                                    <!-- Second row -->
                                    <div class="row signup-body-2">

                                        <div class="col-lg-6 col-md-12 gap">
                                            <label for="surname" class="text-left">Surname:</label>
                                            <input type="text" class="form-control" id="surname" placeholder="Surname" v-model="spouse_data.surname"  autofocus>
                                        </div>
                                        <div class="col-lg-6 col-md-12 gap">
                                            <label for="othername" class="text-left">Othernames:</label>
                                            <input type="text" class="form-control" id="othername" placeholder="Other Name" v-model="spouse_data.othername" >
                                        </div>
                                        <div class="col-lg-6 col-md-12 gap">
                                            <label for="baptismalname-s" class="text-left">Baptismal Name:</label>
                                            <input type="text" class="form-control" id="baptismalname-s" placeholder="Baptismal Name" v-model="spouse_data.baptismal_name" >
                                        </div>
                                        <div class="col-lg-6 col-md-12 gap">
                                            <label for="dob" class="text-left">Date of Birth:</label>
                                            <input type="date" class="form-control" id="dob" v-model="spouse_data.dob" >
                                        </div>
                                        <div class="col-lg-6 col-md-12 gap">
                                            <label for="resident_addr" class="text-left">Residential Address:</label>
                                            <input type="text" class="form-control" id="resident_addr" placeholder="Address" v-model="spouse_data.residential_addr" >
                                        </div>
                                        <div class="col-lg-6 col-md-12 gap">
                                            <label for="occupation" class="text-left">Occupation:</label>
                                            <input type="text" class="form-control" id="occupation" placeholder="Occupation" v-model="spouse_data.occupation" >
                                        </div>
                                        <div class="col-lg-6 col-md-12 gap">
                                            <label for="mobile_tel" class="text-left">Mobile Number:</label>
                                            <input type="tel" class="form-control" id="mobile_tel" placeholder="Mobile Number" v-model="spouse_data.mobile_no" >
                                        </div>
                                        <div class="col-lg-6 col-md-12 gap">
                                            <label for="u_email" class="text-left">Email Address:</label>
                                            <input type="email" class="form-control" id="u_email" placeholder="Email Address" v-model="spouse_data.email" >
                                        </div>
                                        <div class="col-lg-6 col-md-12 gap">
                                            <label for="bcc_center" class="text-left">BCC Center:</label>
                                            <select class="form-control" v-model="spouse_data.bcc_center" id="bcc_center">
                                                <option value="">Select a BCC Center</option>
                                                <option v-for="centers in bcc_centerID.length" :value="bcc_centerID[centers-1]" :key="centers">
                                                    {{bcc_centerName[centers-1]}}
                                                </option>
                                            </select>
                                        </div>
                                        <div class="col-lg-6 col-md-12 gap">
                                            <label for="u_joined" class="text-left">Year of Joining Church:</label>
                                            <input type="number" class="form-control" id="u_joined" placeholder="Year Joined" v-model="spouse_data.yr_joined_church" >
                                        </div>
                                        <div class="col-lg-6 col-md-12 gap">
                                            <div class="row">
                                                <!--                                             Society Details-->
                                                <div class="col-12 gap">
                                                    <h4>Society Details</h4>
                                                </div>
                                                <div class="col-12 gap">
                                                    <div class="row">
                                                        <div class="col-lg-12 col-md-12">
                                                            <h6 class="text-left">Are you a Member of a Society?</h6>
                                                            <div class="col-12 text-left">
                                                                <div class="form-check form-check-inline">
                                                                    <label class="input-mask no-width form-check-input" :class="[spouse_data.society_membership?'active':'']" @click="toggle_inputs_spouse('society_membership', 'yes')">
                                                                        <input class="form-check-input" type="radio" id="society_membership1">
                                                                    </label>
                                                                    <label for="society_membership1" class="text-left no-width form-check-label">Yes</label>
                                                                </div>
                                                                <div class="form-check form-check-inline">
                                                                    <label class="input-mask no-width form-check-input" :class="[spouse_data.society_membership?'':'active']" @click="toggle_inputs_spouse('society_membership', 'no')">
                                                                        <input class="form-check-input" type="radio" id="society_membership2">
                                                                    </label>
                                                                    <label for="society_membership2" class="text-left no-width form-check-label" >No</label>
                                                                </div>
                                                            </div>
                                                            <div v-if="spouse_data.society_membership">
                                                                <span><p class="text-warning">(hold down ctrl to select more than one society)</p></span>
                                                            </div>
                                                            <transition name="custom-name" enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
                                                                <template v-if="spouse_data.society_membership">

                                                                    <select class="form-control" v-model="spouse_data.society_name" multiple>
                                                                        <option v-for="society in societyID.length" :value="societyID[society-1]" :key="society">{{societyName[society-1]}}</option>
                                                                    </select>
                                                                </template>
                                                            </transition>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-12 gap">
                                            <div class="row">
                                                <!-- Sacramental Details-->
                                                <div class="col-12 gap">
                                                    <h4>Sacramental Details</h4>
                                                </div>
                                                <div class="col-12 gap">
                                                    <div class="row">
                                                        <div class="col-lg-6 col-md-12">
                                                            <h6 class="text-left">Are you Baptized?</h6>
                                                            <div class="col-12 text-left">
                                                                <div class="form-check form-check-inline">
                                                                    <label class="input-mask no-width form-check-input" :class="[spouse_data.is_baptized?'active':'']" @click="toggle_inputs_spouse('baptism', 'yes')">
                                                                        <input class="form-check-input" type="radio" id="baptized_yes">
                                                                    </label>
                                                                    <label for="baptized_yes" class="text-left no-width form-check-label">Yes</label>
                                                                </div>
                                                                <div class="form-check form-check-inline">
                                                                    <label class="input-mask no-width form-check-input" :class="[spouse_data.is_baptized?'':'active']" @click="toggle_inputs_spouse('baptism', 'no')">
                                                                        <input class="form-check-input" type="radio" id="baptized_no">
                                                                    </label>
                                                                    <label for="baptized_no" class="text-left no-width form-check-label" >No</label>
                                                                </div>
                                                            </div>
                                                            <transition name="custom-name" enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
                                                                <template v-if="spouse_data.is_baptized">
                                                                    <div>
                                                                        <h6 class="text-left">Date of Baptism</h6>
                                                                        <div class="text-left">
                                                                            <input type="date" class="form-control" v-model="spouse_data.baptized_date">
                                                                        </div>
                                                                    </div>
                                                                </template>
                                                            </transition>
                                                        </div>
                                                        <div class="col-lg-6 col-md-12">
                                                            <h6 class="text-left">Are you a Communicant?</h6>
                                                            <div class="col-12 text-left">
                                                                <div class="form-check form-check-inline">
                                                                    <label class="input-mask no-width form-check-input" :class="[spouse_data.is_communicant?'active':'']" @click="toggle_inputs_spouse('communicant', 'yes')">
                                                                        <input class="form-check-input" type="radio" id="communicant_yes">
                                                                    </label>
                                                                    <label for="communicant_yes" class="text-left no-width form-check-label">Yes</label>
                                                                </div>
                                                                <div class="form-check form-check-inline">
                                                                    <label class="input-mask no-width form-check-input" :class="[spouse_data.is_communicant?'':'active']" @click="toggle_inputs_spouse('communicant', 'no')">
                                                                        <input class="form-check-input" type="radio" id="communicant_no">
                                                                    </label>
                                                                    <label for="communicant_no" class="text-left no-width form-check-label" >No</label>
                                                                </div>
                                                            </div>
                                                            <transition name="custom-name" enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
                                                                <template v-if="spouse_data.is_communicant">
                                                                    <div>
                                                                        <h6 class="text-left">Date of Communion</h6>
                                                                        <div class="text-left">
                                                                            <input type="date" class="form-control" v-model="spouse_data.communion_date">
                                                                        </div>
                                                                    </div>
                                                                </template>
                                                            </transition>
                                                        </div>
                                                        <div class="col-lg-6 col-md-12">
                                                            <h6 class="text-left">Are you Confirmed?</h6>
                                                            <div class="col-12 text-left">
                                                                <div class="form-check form-check-inline">
                                                                    <label class="input-mask no-width form-check-input" :class="[spouse_data.is_confirmed?'active':'']" @click="toggle_inputs_spouse('confirmed', 'yes')">
                                                                        <input class="form-check-input" type="radio" id="confirmed_yes">
                                                                    </label>
                                                                    <label for="confirmed_yes" class="text-left no-width form-check-label">Yes</label>
                                                                </div>
                                                                <div class="form-check form-check-inline">
                                                                    <label class="input-mask no-width form-check-input" :class="[spouse_data.is_confirmed?'':'active']" @click="toggle_inputs_spouse('confirmed', 'no')">
                                                                        <input class="form-check-input" type="radio" id="confirmed_no">
                                                                    </label>
                                                                    <label for="confirmed_no" class="text-left no-width form-check-label" >No</label>
                                                                </div>
                                                            </div>
                                                            <transition name="custom-name" enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
                                                                <template v-if="spouse_data.is_confirmed">
                                                                    <div>
                                                                        <h6 class="text-left">Date Confirmed</h6>
                                                                        <div class="text-left">
                                                                            <input type="date" class="form-control" v-model="spouse_data.confirmed_date">
                                                                        </div>
                                                                    </div>
                                                                </template>
                                                            </transition>
                                                        </div>
                                                        <div class="col-lg-6 col-md-12">
                                                            <h6 class="text-left">Are you Married in the catholic church?</h6>
                                                            <div class="col-12 text-left">
                                                                <div class="form-check form-check-inline">
                                                                    <label class="input-mask no-width form-check-input" :class="[spouse_data.is_married?'active':'']" @click="toggle_inputs_spouse('married', 'yes')">
                                                                        <input class="form-check-input" type="radio" id="married_yes">
                                                                    </label>
                                                                    <label for="married_yes" class="text-left no-width form-check-label">Yes</label>
                                                                </div>
                                                                <div class="form-check form-check-inline">
                                                                    <label class="input-mask no-width form-check-input" :class="[spouse_data.is_married?'':'active']" @click="toggle_inputs_spouse('married', 'no')">
                                                                        <input class="form-check-input" type="radio" id="married_no">
                                                                    </label>
                                                                    <label for="married_no" class="text-left no-width form-check-label" >No</label>
                                                                </div>
                                                            </div>
                                                            <transition name="custom-name" enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
                                                                <template v-if="spouse_data.is_married">
                                                                    <div class="p-t-20">
                                                                        <h6 class="text-left">Date of Marriage</h6>
                                                                        <div class="text-left">
                                                                            <input type="date" class="form-control" v-model="spouse_data.married_date">
                                                                        </div>

                                                                        <h6 class="text-left">Name of Parish</h6>
                                                                        <div class="text-left">
                                                                            <input type="text" class="form-control" v-model="spouse_data.married_parish">
                                                                        </div>

                                                                    </div>
                                                                </template>
                                                            </transition>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>


                                    </div>
                                    <!-- next tab -->
                                    <div class="row">
                                        <div class="col-lg-12 col-md-12">
                                            <div class="row align-content-md-center">
                                                <div class="col p-t-20">
                                                    <button type="button" class="btn stdenis-btn" @click.prevent="switchToTab('sectA')"><i class="icon ion-md-arrow-back"></i> Back </button>
                                                </div>
                                                <div class="col p-t-20">
                                                    <button type="button" class="btn stdenis-btn" @click.prevent="switchToTab('sectC')">Proceed <i class="icon ion-md-arrow-forward"></i> </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- SECTION C -->
                                <div class="container-fluid" :class="[sect_c_tab?'show':'hide']">
                                    <div class="row">
                                        <div class="col-12 signup-body-3-head">
                                            <h6 class="text-center">children / ward living with you (enter records in order of age)</h6>
                                            <p class="text text-center text-danger">(for children and wards under 18 years)</p>
                                        </div>
                                        <div class="col-12">
                                            <!-- First Row-->
                                            <div class="row">
                                                <div class="col-12" v-for="count in ward_count" :key="count">
                                                    <h4 class="text-center ward-head" :class="[count === 1?'no-margin-top':'']">
                                                        Ward #{{count}}
                                                        <span class="ward-bin" @click="delete_ward_field(count-1)" v-if="count > 1"><i class="icon ion-md-trash text-danger"></i></span>
                                                    </h4>
                                                    <div class="col-md-12" v-for="(value,key,index) in ward_details[count-1]" :key="index">
                                                        <div class="row">
                                                            <div class="col-12">
                                                                <div class="row">
                                                                    <div class="col-lg-4 col-md-12">
                                                                        <div class="p-2 text-left">
                                                                            <b>{{ward_column_data[index]}}:</b>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-lg-8 col-md-11">
                                                                        <div class="p-2">
                                                                            <template v-if="index === 2">
                                                                                <input type="date" class="form-control" v-model="ward_details[count-1][key]">
                                                                            </template>
                                                                            <template v-else-if="index === 3">
                                                                                <select class="form-control" v-model="ward_details[count-1][key]" >
                                                                                    <option value="">Select a Gender</option>
                                                                                    <option value="male">Male</option>
                                                                                    <option value="female">Female</option>
                                                                                </select>
                                                                            </template>
                                                                            <template v-else-if="index === 5">
                                                                                <div class="col-12 text-left">
                                                                                    <div class="form-check form-check-inline">
                                                                                        <label class="input-mask no-width form-check-input" :class="[ward_details[count-1][key]?'active':'']" @click="toggle_inputs_ward('yes',count-1,key)">
                                                                                            <input class="form-check-input" type="radio" id="ward_baptized_yes">
                                                                                        </label>
                                                                                        <label for="ward_baptized_yes" class="text-left no-width form-check-label">Yes</label>
                                                                                    </div>
                                                                                    <div class="form-check form-check-inline">
                                                                                        <label class="input-mask no-width form-check-input" :class="[ward_details[count-1][key]?'':'active']" @click="toggle_inputs_ward('no', count-1,key)">
                                                                                            <input class="form-check-input" type="radio" id="ward_baptized_no">
                                                                                        </label>
                                                                                        <label for="ward_baptized_no" class="text-left no-width form-check-label" >No</label>
                                                                                    </div>
                                                                                </div>
                                                                            </template>
                                                                            <template v-else-if="index === 6">
                                                                                <div class="col-12 text-left">
                                                                                    <div class="form-check form-check-inline">
                                                                                        <label class="input-mask no-width form-check-input" :class="[ward_details[count-1][key]?'active':'']" @click="toggle_inputs_ward('yes',count-1,key)">
                                                                                            <input class="form-check-input" type="radio" id="ward_communion_yes">
                                                                                        </label>
                                                                                        <label for="ward_communion_yes" class="text-left no-width form-check-label">Yes</label>
                                                                                    </div>
                                                                                    <div class="form-check form-check-inline">
                                                                                        <label class="input-mask no-width form-check-input" :class="[ward_details[count-1][key]?'':'active']" @click="toggle_inputs_ward('no', count-1,key)">
                                                                                            <input class="form-check-input" type="radio" id="ward_communion_no">
                                                                                        </label>
                                                                                        <label for="ward_communion_no" class="text-left no-width form-check-label" >No</label>
                                                                                    </div>
                                                                                </div>
                                                                            </template>
                                                                            <template v-else-if="index === 7">
                                                                                <div class="col-12 text-left">
                                                                                    <div class="form-check form-check-inline">
                                                                                        <label class="input-mask no-width form-check-input" :class="[ward_details[count-1][key]?'active':'']" @click="toggle_inputs_ward('yes',count-1,key)">
                                                                                            <input class="form-check-input" type="radio" id="ward_confirmed_yes">
                                                                                        </label>
                                                                                        <label for="ward_confirmed_yes" class="text-left no-width form-check-label">Yes</label>
                                                                                    </div>
                                                                                    <div class="form-check form-check-inline">
                                                                                        <label class="input-mask no-width form-check-input" :class="[ward_details[count-1][key]?'':'active']" @click="toggle_inputs_ward('no', count-1,key)">
                                                                                            <input class="form-check-input" type="radio" id="ward_confirmed_no">
                                                                                        </label>
                                                                                        <label for="ward_confirmed_no" class="text-left no-width form-check-label" >No</label>
                                                                                    </div>
                                                                                </div>
                                                                            </template>
                                                                            <template v-else>
                                                                                <input type="text" class="form-control" v-model="ward_details[count-1][key]" >
                                                                            </template>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                                <hr>
                                            </div>


                                            <div class="row align-content-md-center">
                                                <div class="col p-t-20">
                                                    <button type="button" class="btn stdenis-btn" @click.prevent="switchToTab('sectB')" style="color:#fff"><i class="icon ion-md-arrow-back"></i> Back</button>
                                                </div>
                                                <div class="col p-t-20">
                                                    <button type="button" class="btn stdenis-btn" @click.prevent="add_ward_field" style="text-transform: lowercase;color:#fff">
                                                        Add Ward <i class="icon ion-md-add"></i>
                                                    </button>
                                                </div>
                                                <div class="col p-t-20">
                                                    <button type="submit" class="btn stdenis-btn" style="color:#fff">Submit <i class="icon ion-md-check"></i> </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    import Swal from 'sweetalert2/dist/sweetalert2.js'
    import {firestoreDB} from '../config/firebase'
    import {firestoreTimeStamp} from "../config/firebase";
    import {firestoreStorage} from "../config/firebase";

    const parishioners = firestoreDB.collection("parishioners");
    const familyCollection = firestoreDB.collection("families");
    const parishionerStorageREF = firestoreStorage.ref();
    const societiesREF = firestoreDB.collection("societies");
    const zonesREF = firestoreDB.collection("zones");
    var batch = firestoreDB.batch();

    export default {
        name: "FamilySignup",
        data(){
            return{
                sect_a_tab:true,sect_b_tab:false,sect_c_tab:false,
                ward_column_data: [
                    'NAME','RELATIONSHIP','Date of Birth',
                    'SEX','SOCIETY',
                    'Is he/she Baptized?','Is he/she communicant?', 'Is he/she Confirmed?',
                ],
                family_members_id:[],
                wards_id: [],
                personal_data: {
                    profile_pic_url:'',
                    profile_pic:'',
                    profile_pic_name:'', profile_pic_ext:'',
                    parishioners_doc_ref:'',
                    form_number:'',
                    date_registered:'',
                    reg_no: '',
                    surname:'',othername:'',sex:'Male',
                    baptismal_name:'',
                    age:'',dob:'',residential_addr:'',
                    occupation:'',
                    mobile_no:'',email:'',
                    bcc_center:'',
                    yr_joined_church:'',
                    organization_name:'',
                    society_membership:false,
                    society_name:[],
                    is_baptized:false, baptized_date:'',
                    is_communicant:false,communion_date:'',
                    is_confirmed:false, confirmed_date:'',
                    is_married:false, married_date:'', married_parish:'',
                },
                spouse_data: {
                    profile_pic_url:'',
                    profile_pic:'',
                    profile_pic_name:'', profile_pic_ext:'',
                    parishioners_doc_ref:'',
                    form_number:'',
                    date_registered:'',
                    reg_no: '',
                    surname:'',othername:'',sex:'Female',
                    baptismal_name: '',
                    age:'',dob:'',residential_addr:'',
                    occupation:'',
                    mobile_no:'',email:'',
                    bcc_center:'',
                    yr_joined_church:'',
                    organization_name:'',
                    society_membership:false,
                    society_name:[],
                    is_baptized:false, baptized_date:'',
                    is_communicant:false, communion_date:'',
                    is_confirmed:false, confirmed_date:'',
                    is_married:false, married_date:'', married_parish:'',
                },
                societyID:[],societyName:[],
                bcc_centerID:[],bcc_centerName:[],
                this_year(){
                    let now = new Date();
                    return now.getFullYear();
                },
                ward_count:1,
                ward_details: [
                    {
                        name:'',
                        relationship:'',
                        dob:'',
                        sex:'',
                        church_society:'',
                        baptized:false,
                        holy_comm:false,
                        confirmed:false,
                    }
                ],
            }
        },
        methods: {
            switchToTab: function(tab){
                switch (tab) {
                    case 'sectA':
                        this.disableAllTabs();
                        this.sect_a_tab = true;
                        // eslint-disable-next-line no-undef
                        windows.scroll_to(0,0);
                        break;
                    case 'sectB':
                        if(this.validate_personal_form_fields()){
                            this.disableAllTabs();
                            this.sect_b_tab = true;
                            // eslint-disable-next-line no-undef
                            windows.scroll_to(0,0);
                        }
                        break;
                    case 'sectC':
                        if(this.validate_spouse_form_fields()){
                            this.disableAllTabs();
                            this.sect_c_tab = true;
                            // eslint-disable-next-line no-undef
                            windows.scroll_to(0,0);
                        }

                }
            },
            disableAllTabs(){
                this.sect_a_tab = this.sect_b_tab = this.sect_c_tab = false;
            },
            toggle_inputs_personal: function(context, value){
                switch (context) {
                    // Society Based selections
                    case 'society_membership':
                        switch (value) {
                            case 'yes':
                                this.personal_data.society_membership = true;
                                break;
                            case 'no':
                                this.personal_data.society_membership = false;
                                break;
                        }
                        break;
                    case 'baptism':
                        switch (value) {
                            case 'yes':
                                this.personal_data.is_baptized = true;
                                break;
                            case 'no':
                                this.personal_data.is_baptized = false;
                                break;
                        }
                        break;
                    case 'communicant':
                        switch (value) {
                            case 'yes':
                                this.personal_data.is_communicant = true;
                                break;
                            case 'no':
                                this.personal_data.is_communicant = false;
                                break;
                        }
                        break;
                    case 'confirmed':
                        switch (value) {
                            case 'yes':
                                this.personal_data.is_confirmed = true;
                                break;
                            case 'no':
                                this.personal_data.is_confirmed = false;
                                break;
                        }
                        break;
                    case 'married':
                        switch (value) {
                            case 'yes':
                                this.personal_data.is_married = true;
                                break;
                            case 'no':
                                this.personal_data.is_married = false;
                                break;
                        }
                        break;
                }

            },
            toggle_inputs_spouse: function(context, value){
                switch (context) {
                    // Society Based selections
                    case 'society_membership':
                        switch (value) {
                            case 'yes':
                                this.spouse_data.society_membership = true;
                                break;
                            case 'no':
                                this.spouse_data.society_membership = false;
                                break;
                        }
                        break;
                    case 'baptism':
                        switch (value) {
                            case 'yes':
                                this.spouse_data.is_baptized = true;
                                break;
                            case 'no':
                                this.spouse_data.is_baptized = false;
                                break;
                        }
                        break;
                    case 'communicant':
                        switch (value) {
                            case 'yes':
                                this.spouse_data.is_communicant = true;
                                break;
                            case 'no':
                                this.spouse_data.is_communicant = false;
                                break;
                        }
                        break;
                    case 'confirmed':
                        switch (value) {
                            case 'yes':
                                this.spouse_data.is_confirmed = true;
                                break;
                            case 'no':
                                this.spouse_data.is_confirmed = false;
                                break;
                        }
                        break;
                    case 'married':
                        switch (value) {
                            case 'yes':
                                this.spouse_data.is_married = true;
                                break;
                            case 'no':
                                this.spouse_data.is_married = false;
                                break;
                        }
                        break;
                }

            },
            toggle_inputs_ward: function(value, count, key){
                // ward baptism selections
                switch (value) {
                    case 'yes':
                        this.ward_details[count][key] = true;
                        break;
                    case 'no':
                        this.ward_details[count][key] = false;
                        break;
                }

            },
            toggle_passport_upload: function(diff){
                // eslint-disable-next-line no-undef
                let passport_box = $('#stdenis-passport-'+diff);
                passport_box.trigger('click');
            },
            verify_profile_pic_upload(diff){
                let passport = document.getElementById('stdenis-passport-'+diff);
                let ext = passport.value.split('.').pop().toLowerCase();
                // eslint-disable-next-line no-undef
                if ($.inArray(ext, ['gif','png','jpg','jpeg']) === -1){
                    this.display_alert('Oops...', 'incorrect file type!', 'error');
                    passport.value = "";
                    if(diff == '1'){
                        this.personal_data.profile_pic_url = "";
                        // eslint-disable-next-line no-undef
                        let upload_hint = $('.js-p-frame');
                        // eslint-disable-next-line no-undef
                        $('.js-personal').css('background-image', '');
                        upload_hint.css('opacity', 1);
                    }else{
                        this.spouse_data.profile_pic_url = "";
                        // eslint-disable-next-line no-undef
                        let upload_hint = $('.js-s-frame');
                        // eslint-disable-next-line no-undef
                        $('.js-spouse').css('background-image', '');
                        upload_hint.css('opacity', 1);
                    }

                }else{
                    if(diff == '1'){
                        // eslint-disable-next-line no-undef
                        let upload_hint = $('.js-p-frame');
                        upload_hint.css('opacity', 0);
                        this.read_file_url(passport, diff);
                    }else{
                        // eslint-disable-next-line no-undef
                        let upload_hint = $('.js-s-frame');
                        upload_hint.css('opacity', 0);
                        this.read_file_url(passport, diff);
                    }

                }
            },
            read_file_url(input, diff){
                if (input.files && input.files[0]) {
                    let reader = new FileReader();
                    reader.onload = (e) => {
                        if(diff == '1'){
                            // eslint-disable-next-line no-undef
                            $('.js-personal').css('background-image', 'url('+e.target.result+')');
                            this.personal_data.profile_pic_url = e.target.result;
                            this.personal_data.profile_pic = input.files[0];
                            // save image extension
                            this.personal_data.profile_pic_ext = input.files[0].name.split('.').pop();
                        }else{
                            // eslint-disable-next-line no-undef
                            $('.js-spouse').css('background-image', 'url('+e.target.result+')');
                            this.spouse_data.profile_pic_url = e.target.result;
                            this.spouse_data.profile_pic = input.files[0];
                            // save image extension
                            this.spouse_data.profile_pic_ext = input.files[0].name.split('.').pop();
                        }

                    };
                    reader.readAsDataURL(input.files[0]);
                }
            },
            set_todays_date: function(inputID){
                let now = new Date();
                let day = ("0" + now.getDate()).slice(-2);
                let month = ("0" + (now.getMonth() + 1)).slice(-2);
                let today = now.getFullYear() + "-" + (month)+"-"+(day) ;

                // eslint-disable-next-line no-undef
                $(inputID).val(today);
                this.date_registered = today;
            },
            validate_personal_form_fields(){
                if(this.personal_data.profile_pic_url.length <= 0){
                    this.display_alert('Oops...', 'Upload your passport', 'warning');
                    return false
                }
                if(this.personal_data.surname.length <= 0){
                    this.display_alert('Oops...', 'fill in your surname', 'warning');
                    return false
                }
                if(this.personal_data.othername.length <= 0){
                    this.display_alert('Oops...', 'fill in your other name', 'warning');
                    return false
                }
                if(this.personal_data.sex.length <= 0){
                    this.display_alert('Oops...', 'fill in your gender', 'warning');
                    return false
                }
                if(this.personal_data.dob.length <= 0){
                    this.display_alert('Oops...', 'fill in your date of birth', 'warning');
                    return false
                }
                if(this.personal_data.residential_addr.length <= 0){
                    this.display_alert('Oops...', 'fill in your residential address', 'warning');
                    return false
                }
                if(this.personal_data.occupation.length <= 0){
                    this.display_alert('Oops...', 'fill in your occupation', 'warning');
                    return false
                }
                if(this.personal_data.mobile_no.length <= 6){
                    this.display_alert('Oops...', 'invalid mobile number', 'error');
                    return false
                }
                if(this.personal_data.email.length <= 0){
                    this.display_alert('Oops...', 'fill in your email address', 'warning');
                    return false
                }
                if(!this.is_email(this.personal_data.email)){
                    this.display_alert('Oops...', 'incorrect email format', 'error');
                    return false
                }
                if(this.personal_data.bcc_center.length <= 0){
                    this.display_alert('Oops...', 'fill in your BCC Center', 'warning');
                    return false
                }
                if(this.personal_data.yr_joined_church > this.this_year() || this.personal_data.yr_joined_church <= 1 ){
                    this.display_alert('Oops...', 'fill in a valid year', 'warning');
                    return false
                }
                if(this.personal_data.society_membership === true){
                    if(this.personal_data.society_name.length <= 0){
                        this.display_alert('Oops...', 'fill in your society\'s name', 'warning');
                        return false
                    }
                }
                if(this.personal_data.is_baptized === true){
                    if(this.personal_data.baptized_date.length <= 0){
                        this.display_alert('Oops...', 'fill in your baptismal date', 'warning');
                        return false
                    }
                }
                if(this.personal_data.is_confirmed === true){
                    if(this.personal_data.confirmed_date.length <= 0){
                        this.display_alert('Oops...', 'fill in your confirmation date', 'warning');
                        return false
                    }
                }
                if(this.personal_data.is_communicant === true){
                    if(this.personal_data.communion_date.length <= 0){
                        this.display_alert('Oops...', 'fill in your first holy communion date', 'warning');
                        return false
                    }
                }
                if(this.personal_data.is_married === true){
                    if(this.personal_data.married_date.length <= 0 || this.personal_data.married_parish.length <= 0){
                        this.display_alert('Oops...', 'fill in the remaining marriage details', 'warning');
                        return false
                    }
                }
                return true
                // this.submit_signup_details();
            },
            validate_spouse_form_fields(){
                if(this.spouse_data.profile_pic_url.length <= 0){
                    this.display_alert('Oops...', 'Upload your passport', 'warning');
                    return false
                }
                if(this.spouse_data.surname.length <= 0){
                    this.display_alert('Oops...', 'fill in your surname', 'warning');
                    return false
                }
                if(this.spouse_data.othername.length <= 0){
                    this.display_alert('Oops...', 'fill in your other name', 'warning');
                    return false
                }
                if(this.spouse_data.sex.length <= 0){
                    this.display_alert('Oops...', 'fill in your gender', 'warning');
                    return false
                }
                if(this.spouse_data.dob.length <= 0){
                    this.display_alert('Oops...', 'fill in your date of birth', 'warning');
                    return false
                }
                if(this.spouse_data.residential_addr.length <= 0){
                    this.display_alert('Oops...', 'fill in your residential address', 'warning');
                    return false
                }
                if(this.spouse_data.occupation.length <= 0){
                    this.display_alert('Oops...', 'fill in your occupation', 'warning');
                    return false
                }
                if(this.spouse_data.mobile_no.length <= 6){
                    this.display_alert('Oops...', 'invalid mobile number', 'error');
                    return false
                }
                if(this.spouse_data.email.length <= 0){
                    this.display_alert('Oops...', 'fill in your email address', 'warning');
                    return false
                }
                if(!this.is_email(this.spouse_data.email)){
                    this.display_alert('Oops...', 'incorrect email format', 'error');
                    return false
                }
                if(this.spouse_data.bcc_center.length <= 0){
                    this.display_alert('Oops...', 'fill in your BCC Center', 'warning');
                    return false
                }
                if(this.spouse_data.yr_joined_church > this.this_year() || this.spouse_data.yr_joined_church <= 1 ){
                    this.display_alert('Oops...', 'fill in a valid year', 'warning');
                    return false
                }
                if(this.spouse_data.society_membership === true){
                    if(this.spouse_data.society_name.length <= 0){
                        this.display_alert('Oops...', 'fill in your society\'s name', 'warning');
                        return false
                    }
                }
                if(this.spouse_data.is_baptized === true){
                    if(this.spouse_data.baptized_date.length <= 0){
                        this.display_alert('Oops...', 'fill in your baptismal date', 'warning');
                        return false
                    }
                }
                if(this.spouse_data.is_confirmed === true){
                    if(this.spouse_data.confirmed_date.length <= 0){
                        this.display_alert('Oops...', 'fill in your confirmation date', 'warning');
                        return false
                    }
                }
                if(this.spouse_data.is_communicant === true){
                    if(this.spouse_data.communion_date.length <= 0){
                        this.display_alert('Oops...', 'fill in your first holy communion date', 'warning');
                        return false
                    }
                }
                if(this.spouse_data.is_married === true){
                    if(this.spouse_data.married_date.length <= 0 || this.spouse_data.married_parish.length <= 0){
                        this.display_alert('Oops...', 'fill in the remaining marriage details', 'warning');
                        return false
                    }
                }
                return true
                // this.submit_signup_details();
            },
            display_alert: function(msg_head, message, error_type){
                Swal.fire({
                    title: msg_head,
                    showClass: {
                        popup: 'animated fadeInDown faster'
                    },
                    hideClass: {
                        popup: 'animated fadeOutUp faster'
                    },
                    text: message,
                    icon: error_type,
                    showCancelButton: false,
                    showConfirmButton: false,
                    timer: 2000

                })
            },
            is_email(email){
                var regex = /^([a-zA-Z0-9_.+-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
                return regex.test(email);
            },
            submit_signup_details(){
                let loader = this.showLoadingOverlay();
                let husbandData = {
                    zone: this.personal_data.bcc_center,
                    baptismalName: this.personal_data.baptismal_name,
                    dateCreated: firestoreTimeStamp,
                    dateOfBaptism: this.formatDate(this.personal_data.baptized_date),
                    dateOfBirth: this.formatDate(this.personal_data.dob),
                    dateOfConfirmation: this.formatDate(this.personal_data.confirmed_date),
                    dateOfFirstCommunion: this.formatDate(this.personal_data.communion_date),
                    dateOfMarriage: this.formatDate(this.personal_data.married_date),
                    dateUpdated: firestoreTimeStamp,
                    email: this.personal_data.email,
                    familyID: '',
                    isBaptised: this.personal_data.is_baptized,
                    isCommunicant: this.personal_data.is_communicant,
                    isConfirmed: this.personal_data.is_confirmed,
                    isMarriedInChurch: this.personal_data.is_married,
                    nameOfParishWedded: this.personal_data.married_parish,
                    occupation: this.personal_data.occupation,
                    otherName: this.personal_data.othername,
                    parishID: 2,
                    phone: this.personal_data.mobile_no,
                    picture: '',
                    regNumber:'',
                    residentialAddress: this.personal_data.residential_addr,
                    sex: this.personal_data.sex,
                    societies: this.personal_data.society_name,
                    surname: this.personal_data.surname,
                    yearOfJoiningChurch: this.personal_data.yr_joined_church
                };
                let spouseData = {
                    zone: this.spouse_data.bcc_center,
                    baptismalName: this.spouse_data.baptismal_name,
                    dateCreated: firestoreTimeStamp,
                    dateOfBaptism: this.formatDate(this.spouse_data.baptized_date),
                    dateOfBirth: this.formatDate(this.spouse_data.dob),
                    dateOfConfirmation: this.formatDate(this.spouse_data.confirmed_date),
                    dateOfFirstCommunion: this.formatDate(this.spouse_data.communion_date),
                    dateOfMarriage: this.formatDate(this.spouse_data.married_date),
                    dateUpdated: firestoreTimeStamp,
                    email: this.spouse_data.email,
                    familyID: '',
                    isBaptised: this.spouse_data.is_baptized,
                    isCommunicant: this.spouse_data.is_communicant,
                    isConfirmed: this.spouse_data.is_confirmed,
                    isMarriedInChurch: this.spouse_data.is_married,
                    nameOfParishWedded: this.spouse_data.married_parish,
                    occupation: this.spouse_data.occupation,
                    otherName: this.spouse_data.othername,
                    parishID: 2,
                    phone: this.spouse_data.mobile_no,
                    picture: '',
                    regNumber:'',
                    residentialAddress: this.spouse_data.residential_addr,
                    sex: this.spouse_data.sex,
                    societies: this.spouse_data.society_name,
                    surname: this.spouse_data.surname,
                    yearOfJoiningChurch: this.spouse_data.yr_joined_church
                };

                parishioners.add(husbandData).then((docRef) => {
                    // uploading husband data
                    this.personal_data.parishioners_doc_ref = docRef.id;
                    this.family_members_id.push(docRef.id);
                    let filename = this.personal_data.surname + this.personal_data.othername;
                    this.personal_data.profile_pic_name = filename + '.'+ this.personal_data.profile_pic_ext;
                    const parishionersImageRef = parishionerStorageREF.child('parishioners_photo/St. Denis Catholic Church Bariga/'+ filename + '/' +this.personal_data.profile_pic_name);
                    return parishionersImageRef.put(this.personal_data.profile_pic)

                }).then(snapshot => {
                    return snapshot.ref.getDownloadURL()
                }).then(url => {
                    let ParishionerREF = parishioners.doc(this.personal_data.parishioners_doc_ref);
                    return ParishionerREF.update({
                        picture: url,
                    })
                }).then(() => {
                    // Uploading spouse data
                    parishioners.add(spouseData).then((docRef) => {
                        this.spouse_data.parishioners_doc_ref = docRef.id;
                        this.family_members_id.push(docRef.id);
                        let filename = this.spouse_data.surname + this.spouse_data.othername;
                        this.spouse_data.profile_pic_name = filename + '.'+ this.spouse_data.profile_pic_ext;
                        const parishionersImageRef = parishionerStorageREF.child('parishioners_photo/St. Denis Catholic Church Bariga/'+ filename + '/' +this.spouse_data.profile_pic_name);
                        return parishionersImageRef.put(this.spouse_data.profile_pic)

                    }).then(snapshot => {
                        return snapshot.ref.getDownloadURL()
                    }).then(url => {
                        let ParishionerREF = parishioners.doc(this.spouse_data.parishioners_doc_ref);
                        return ParishionerREF.update({
                            picture: url,
                        })
                    }).then(() => {
                        if(this.validateWardFields()){
                            // push wards data
                            for(let i = 0; i < this.ward_details.length; i++) {
                                let wardData = {
                                    BCC: '',
                                    baptismalName: this.ward_details[i].name,
                                    dateCreated: firestoreTimeStamp,
                                    dateOfBaptism: '',
                                    dateOfBirth: this.formatDate(this.ward_details[i].dob),
                                    dateOfConfirmation: '',
                                    dateOfFirstCommunion: '',
                                    dateOfMarriage: '',
                                    dateUpdated: firestoreTimeStamp,
                                    email: '',
                                    familyID: '',
                                    isBaptised: this.ward_details[i].baptized,
                                    isCommunicant: this.ward_details[i].holy_comm,
                                    isConfirmed: this.ward_details[i].confirmed,
                                    isMarriedInChurch: '',
                                    nameOfParishWedded: '',
                                    occupation: '',
                                    otherName: '',
                                    parishID: 2,
                                    phone: '',
                                    mobile: '',
                                    picture: '',
                                    regNumber: '',
                                    residentialAddress: '',
                                    sex: this.ward_details[i].sex,
                                    societies: this.ward_details[i].church_society,
                                    surname: this.personal_data.surname,
                                    yearOfJoiningChurch: ''
                                };
                                let auto_parish_doc = parishioners.doc();
                                batch.set(auto_parish_doc, wardData);
                                this.wards_id.push(auto_parish_doc.id);
                                this.family_members_id.push(auto_parish_doc.id);
                            }
                            // return batch.commit()
                        }
                    }).then(() => {
                        let familyData = {
                            members: this.family_members_id,
                            name: this.personal_data.surname + " " + this.personal_data.othername,
                            dateCreated: firestoreTimeStamp
                        };
                        familyCollection.add(familyData).then((docRef) => {
                            // update each member with the family id
                            let ParishionerREF = parishioners.doc(this.personal_data.parishioners_doc_ref);
                            return ParishionerREF.update({
                                familyID: docRef.id,
                            }).then(() => {
                                let ParishionerREF = parishioners.doc(this.spouse_data.parishioners_doc_ref);
                                return ParishionerREF.update({
                                    familyID: docRef.id,
                                })
                            }).then(() => {
                                for(let i = 0; i < this.wards_id.length; i++){
                                    batch.update(parishioners.doc(this.wards_id[i]), {familyID: docRef.id });
                                }
                                batch.commit().then(() => {
                                    loader.hide();
                                    setTimeout(() => {
                                        this.display_alert('success', 'Request Submitted', 'success');
                                        this.$router.push({path: '/'})
                                    }, 1000);
                                });
                            })
                        })

                    })
                })
                    .catch((error) => {
                        loader.hide();
                        setTimeout(() => {
                            switch (error.code) {
                                case 'permission-denied':
                                    this.display_alert('Error', "Permission Denied!", 'error');
                                    break;
                                default:
                                    this.display_alert('Error', error, 'error');
                            }
                        }, 1000);

                    });
            },
            showLoadingOverlay(){
                return this.$loading.show({
                    // Optional parameters
                    container: this.fullPage ? null : this.$refs.formContainer,
                    canCancel: false,
                });
            },
            add_ward_field: function(){
                if(!this.validateWardFields()){
                    this.display_alert('Note', 'Fill in all empty fields before adding a new one', 'warning');
                }else{
                    this.ward_count++;
                    // let random_string = '#HJSGJ556';
                    // this.ward_reg.push(random_string);
                    this.ward_details.push(
                        {
                            name:'',
                            relationship:'',
                            age:'',
                            sex:'',
                            church_society:'',
                            baptized:'',
                            holy_comm:'',
                            confirmed:''
                        }
                    )
                }
            },
            delete_ward_field: function(index){
                this.ward_count--;
                // let position = this.ward_reg.indexOf(reg_no);
                // if (position > -1) {
                //     this.ward_reg.splice(index, 1); // deleting the reg no
                // }
                this.ward_details.splice(index,1) // deleting the ward object details
            },
            formatDate(dateinputValue){
                if(dateinputValue){
                    return Date(dateinputValue);
                }
                return ""

            },
            validateWardFields(){
                for(let i = 0; i < this.ward_details.length; i++){
                    if(this.ward_details[i].name === '' || this.ward_details[i].relationship === '' || this.ward_details[i].dob === '' || this.ward_details[i].sex === '' || this.ward_details[i].church_society === ''){
                        return false
                    }
                }
                return true
            },
            fetchSocieties(){
                societiesREF.get().then((querySnapshot) => {
                    querySnapshot.forEach((doc) => {
                        // doc.data() is never undefined for query doc snapshots
                        let societyID = doc.id;
                        let societyObj = doc.data();
                        this.societyID.push(societyID);
                        this.societyName.push(societyObj.name);
                    });
                }).catch((error) => {
                    console.warn("Societies Fetch Error: "+error)
                });
            },
            fetchZones(){
                zonesREF.get().then((querySnapshot) => {
                    querySnapshot.forEach((doc) => {
                        // doc.data() is never undefined for query doc snapshots
                        let zoneID = doc.id;
                        let zoneObj = doc.data();
                        this.bcc_centerID.push(zoneID);
                        this.bcc_centerName.push(zoneObj.name);
                    });
                }).catch((error) => {
                    console.warn("Zones Fetch Error: "+error)
                });
            }
        },
        mounted() {
            // Scroll to top page
            window.scrollTo(0, 0);

            // eslint-disable-next-line no-undef
            let passport_1 = $('#stdenis-passport-1');
            // eslint-disable-next-line no-undef
            let passport_2 = $('#stdenis-passport-2');
            passport_1.val(this.personal_data.profile_pic_url);
            passport_2.val(this.spouse_data.profile_pic_url)

            this.fetchSocieties();  // Fetch all societies
            this.fetchZones();      // Fetch all bcc zones

        }
    }
</script>

<style scoped>
    .m-b-20{margin-bottom:20px}
    .p-t-20{padding-top:20px}
    .show{display:block}
    .hide{display: none}
    @media screen and (min-width: 320px){
        .stdenis-indivsignup{
            padding: 20px 0;
        }
        .signup-container{
            border: 2px solid #000;
            padding:30px;
        }
        .signup-body-1{
            padding:20px 20px 10px 20px;
        }
        .signup-body-1:nth-child(2){
            padding-top:0;
        }
        .signup-container .signup-head{
            border: 1px solid #000;
        }
        .pic-frame{
            width:100%;
            height:200px;
            border: 1px solid #439EF3;
            border-radius: 10px;
            background: no-repeat center center;
            background-size: cover;
        }
        .frame-overlay{
            height:100%;
            border-radius: 5px;
            transition: .5s;
            padding:70px 20px
        }
        .pic-frame:hover{
            cursor: pointer;
        }
        .pic-frame:hover .frame-overlay{
            opacity: 1;
        }
        .pic-frame input[type="file"]{
            visibility: hidden;
        }
        label{
            width:100%
        }
        .no-width{
            width:auto;
        }
        .signup-body-2{
            padding-top:20px
        }
        .signup-body-2 .gap{
            margin-bottom: 10px;
        }

        .input-mask{
            width:20px;
            height:20px;
            background-color: rgb(200,200,200);
            margin-right:10px;
            border-radius: 5px;
        }
        .input-mask:hover{
            cursor: pointer;
        }
        .input-mask.active{
            background-color: #E12993;
        }
        .input-mask > input{
            visibility: hidden;
            position: absolute;
            width:100%;
            height:100%;
            top:0;
            left:0
        }
        .signup-body-header .nav-item:hover{
            cursor: pointer;
        }
        .signup-body-header .nav-item .active{
            background-color: #439EF3;
            color:#fff
        }
        .signup-body-3-head{
            padding:20px
        }
        .signup-body-3-head h6{
            text-transform: uppercase;
            font-size: .9rem;
        }
        .ward-table .ward-bin:hover{
            cursor: pointer;
        }
        .ward-table .ward-bin i{
            font-size:24px;
        }
        .signup-head .head-img img{
            width: 100px;
            height:100px;
        }
        .signup-head .head-text h1{
            font-size: 1.3rem;
        }
        .signup-head .head-text h4{
            font-size: .9rem;
        }
        .signup-body-1 .head-text h4{
            font-size: 1.2rem;
        }
        .signup-body-header h2{
            font-size: 1.5rem;
        }
        .signup-body-header h4{
            font-size: 1.2rem;
        }
        .ward-head:nth-child(1){
            border-bottom: 1px solid rgba(0,0,0,.1);
        }
        .no-margin-top{
            margin-top:0!important;
        }
        .ward-head{
            margin-top:40px
        }
    }
    @media screen and (min-width: 1024px){
        .signup-head .head-text .head-img img{
            max-width: 100%;
            height:auto!important;
        }
        .signup-head .head-text h1{
            font-size: 2.5rem;
        }
        .signup-head .head-text h4, .signup-body-1 .head-text h4, .signup-body-header h4{
            font-size: 1.5rem;
        }
        .signup-body-header h2{
            font-size: 2rem;
        }
        .signup-body-3-head h6{
            font-size: 1rem;
        }
    }
</style>